window.AppEvents.subscribe("ADD_TO_CART",(data,eventId) => {
    fetch("/api/event", {
        method: "POST",
        headers: http.headers(),
        body: JSON.stringify({
            eventId: eventId,
            payload: data,
            event: "ADD_TO_CART",
            url: location.href,
            utm_source: sessionStorage.getItem("utm_source") ?? "",
            utm_medium: sessionStorage.getItem("utm_medium") ?? "",
            utm_campaign: sessionStorage.getItem("utm_campaign") ?? "",
            utm_content: sessionStorage.getItem("utm_content") ?? "",
            utm_term: sessionStorage.getItem("utm_term") ?? "",
            referrer: sessionStorage.getItem("referrer") ?? "",
        }),
    })
});
window.AppEvents.subscribe("CUSTOMIZE_PRODUCT",(data,eventId) => {
    fetch("/api/event", {
        method: "POST",
        headers: http.headers(),
        body: JSON.stringify({
            eventId: eventId,
            payload: data,
            event: "CUSTOMIZE_PRODUCT",
            url: location.href,
            utm_source: sessionStorage.getItem("utm_source") ?? "",
            utm_medium: sessionStorage.getItem("utm_medium") ?? "",
            utm_campaign: sessionStorage.getItem("utm_campaign") ?? "",
            utm_content: sessionStorage.getItem("utm_content") ?? "",
            utm_term: sessionStorage.getItem("utm_term") ?? "",
            referrer: sessionStorage.getItem("referrer") ?? "",
        }),
    })
});
